var map = {
	"./AdminFavourites.vue": 36577,
	"./AdminOrders.vue": 47878,
	"./AdminStockItemAlternatives.vue": 83220,
	"./Cart.vue": 51628,
	"./CustomerCare.vue": 15038,
	"./Deliveries.vue": 25581,
	"./EditCategory.vue": 99013,
	"./EditCostCentre.vue": 16241,
	"./EditCustomerLocation.vue": 89675,
	"./EditDelivery.vue": 4982,
	"./EditDeliveryDate.vue": 5817,
	"./EditDivision.vue": 46232,
	"./EditEmail.vue": 68918,
	"./EditEmailLog.vue": 57910,
	"./EditPickingList.vue": 61468,
	"./EditPickingListItem.vue": 54424,
	"./EditPreferredDeliveryAddress.vue": 32747,
	"./EditPurchaseLimit.vue": 12892,
	"./EditQuote.vue": 66243,
	"./EditRestaurantAdmin.vue": 94022,
	"./EditSoftSaleStockItem.vue": 3359,
	"./EditStockItem.vue": 575,
	"./EditStockItemAlternative.vue": 75805,
	"./EditSupplier.vue": 19724,
	"./Favourites.vue": 78044,
	"./ListCategory.vue": 8873,
	"./ListCostCentre.vue": 57604,
	"./ListCustomerLocation.vue": 73947,
	"./ListDelivery.vue": 78659,
	"./ListDeliveryDate.vue": 9272,
	"./ListDivision.vue": 53705,
	"./ListEmail.vue": 21439,
	"./ListOrder.vue": 34397,
	"./ListPickingList.vue": 97202,
	"./ListPickingListItem.vue": 43662,
	"./ListPreferredDeliveryAddress.vue": 94242,
	"./ListPurchaseLimit.vue": 98557,
	"./ListQuotes.vue": 33013,
	"./ListRestaurantAdmin.vue": 65813,
	"./ListStockItem.vue": 55800,
	"./ListSupplier.vue": 89338,
	"./MyOrders.vue": 44298,
	"./OrderConfirmed.vue": 80165,
	"./Orders.vue": 51290,
	"./PickingList.vue": 72791,
	"./ProductRequest.vue": 27694,
	"./Quote.vue": 51544,
	"./SalesDashboard.vue": 42955,
	"./ShopCategories.vue": 40327,
	"./ShopCategoriesHorizontal.vue": 14760,
	"./ShopHome.vue": 23499,
	"./ShopSearch.vue": 4011,
	"./ShopStockItem.vue": 70109,
	"./ShopStockItemByCategory.vue": 12244,
	"./ShopStockItems.vue": 40831,
	"./StockItemDetail.vue": 28976
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47780;